export default {
  title: '搜尋類似案件',
  desc: '點擊以選擇或排除與本判決書相關的標籤以作查詢。',
  search_desc: '此搜尋將列出符合最多「包括」標籤的判決書。',
  lang_support: '此功能暫時只支援英語搜尋。',
  show_tree: '層遞排列',
  hide_tree: '緊密排列',
  include: '包括',
  exclude: '排除',
  tag_indicator_help: '標籤的顏色有何區別？',
  tag_dark: '深色標籤',
  tag_dark_exp: ' 代表判決書有直接提及該概念',
  tag_light: '淺色標籤',
  tag_light_exp: ' 為與判決書相關的延伸概念',
  selected: '已選搜尋條件',
  result: '相關判決書',
  return_to_tags: '返回標籤選擇',
  beta_hint:'判案書的標籤是用AI技術生成的，請擊點閱讀相關資訊。歡迎填寫意見表格提供意見及回報錯誤。',
}